"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ReactIdSwiper = _interopRequireDefault(require("react-id-swiper/lib/ReactIdSwiper.custom"));
var _Arrow = require("b2b-components/theme/components/Gallery/Arrow");
var _Modal = require("b2b-components/theme/components/Modal");
var _classnames = _interopRequireDefault(require("classnames"));
var _swiper = _interopRequireWildcard(require("swiper"));
require("./Gallery.scss");
require("swiper/swiper-bundle.min.css");
require("swiper/swiper.min.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Gallery = _ref => {
  let {
    className,
    images,
    title
  } = _ref;
  const [isModalOpened, setIsModalOpened] = (0, _react.useState)(false);
  const onModalClose = () => {
    setIsModalOpened(false);
  };
  const onModalOpen = () => {
    setIsModalOpened(true);
  };
  const gallerySwiperRef = (0, _react.useRef)(null);
  const modalSwiperRef = (0, _react.useRef)(null);
  if (!images || !Array.isArray(images)) {
    return null;
  }
  const params = {
    Swiper: _swiper.default,
    modules: [_swiper.Navigation, _swiper.Pagination],
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    },
    keyboard: {
      enabled: true
    },
    navigation: {
      nextEl: `.${_Arrow.ARROW_CLASS_NAME_NEXT}`,
      prevEl: `.${_Arrow.ARROW_CLASS_NAME_PREV}`
    },
    renderNextButton: () => /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
      type: _Arrow.ARROW_TYPE.next,
      className: "cds-cms-GalleryArrow"
    }),
    renderPrevButton: () => /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
      type: _Arrow.ARROW_TYPE.prev,
      className: "cds-cms-GalleryArrow"
    }),
    spaceBetween: 30
  };
  const rootClassName = (0, _classnames.default)('cds-cms-Gallery', className);
  const renderModalBody = () => {
    const modalInitialSlide = gallerySwiperRef?.current?.swiper?.realIndex || 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, title && /*#__PURE__*/_react.default.createElement("h5", {
      className: "cds-cms-GalleryTitle"
    }, title), /*#__PURE__*/_react.default.createElement(_ReactIdSwiper.default, (0, _extends2.default)({}, params, {
      ref: modalSwiperRef,
      initialSlide: modalInitialSlide
    }), images.map((image, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-cms-GallerySlideWrapper",
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-cms-GallerySlide"
    }, /*#__PURE__*/_react.default.createElement("img", {
      key: index,
      alt: image.title,
      className: "cds-cms-GalleryImage",
      onClick: onModalOpen,
      src: image.url
    }), !!image.caption && /*#__PURE__*/_react.default.createElement("span", {
      className: "cds-cms-GalleryCaption"
    }, image.caption))))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, title && /*#__PURE__*/_react.default.createElement("h5", {
    className: "cds-cms-GalleryTitle"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-GallerySliderWrapper"
  }, /*#__PURE__*/_react.default.createElement(_ReactIdSwiper.default, (0, _extends2.default)({}, params, {
    ref: gallerySwiperRef
  }), images.map((image, index) => /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-GallerySlideWrapper",
    key: index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-GallerySlide"
  }, /*#__PURE__*/_react.default.createElement("img", {
    key: index,
    alt: image.title,
    className: "cds-cms-GalleryImage",
    onClick: onModalOpen,
    src: image.url
  }), !!image.caption && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-GalleryCaption"
  }, image.caption)))))), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    content: renderModalBody,
    isOpen: isModalOpened,
    onCloseModal: onModalClose,
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.Gallery = Gallery;
//# sourceMappingURL=Gallery.js.map